<a routerLink="/queue" class="back-link">
  <mat-icon>arrow_back</mat-icon>
  Back to queue
</a>

@if (loading()) {
  <div class="detail-loading">
    <mat-spinner diameter="32" />
  </div>
} @else if (errorMessage()) {
  <p class="detail-error">{{ errorMessage() }}</p>
} @else if (transaction(); as t) {
  <div class="page-header">
    <div>
      <h1 class="detail-title">
        <span class="mono">{{ t.control_reference }}</span>
        <app-status-badge [state]="t.state" />
      </h1>
      <p>{{ t.service_type }} &middot; Created {{ t.created_at | date: 'MMM d, y, h:mm a' }}</p>
    </div>
  </div>

  <div class="detail-layout">
    <div class="detail-main">
      <section class="card-surface detail-card">
        <h2>Overview</h2>
        <dl class="detail-grid">
          <div><dt>Client Transaction ID</dt><dd>{{ t.client_transaction_id }}</dd></div>
          <div><dt>Request ID</dt><dd>{{ t.request_id }}</dd></div>
          <div><dt>Source Entity</dt><dd>{{ t.source_entity_id }} (wallet type {{ t.source_wallet_type_id }})</dd></div>
          <div><dt>Trigger Reason</dt><dd>{{ t.trigger_reason.replaceAll('_', ' ') }}</dd></div>
        </dl>
      </section>

      <section class="card-surface detail-card">
        <h2>Amount</h2>
        <p class="detail-amount">
          {{ t.amount | currency: t.currency : 'symbol-narrow' : '1.2-2' }}
        </p>
        <dl class="detail-grid detail-grid--tight">
          <div><dt>Fees</dt><dd>{{ t.fees | currency: t.currency : 'symbol-narrow' : '1.2-2' }}</dd></div>
          <div><dt>Charges</dt><dd>{{ t.charges | currency: t.currency : 'symbol-narrow' : '1.2-2' }}</dd></div>
          <div><dt>Hold Amount</dt><dd>{{ t.hold_amount | currency: t.currency : 'symbol-narrow' : '1.2-2' }}</dd></div>
        </dl>
      </section>

      <section class="card-surface detail-card">
        <h2>Beneficiary</h2>
        <dl class="detail-grid">
          <div><dt>Bank Code</dt><dd>{{ t.beneficiary_bank_code }}</dd></div>
          <div><dt>Account</dt><dd class="mono">{{ t.beneficiary_account_masked }}</dd></div>
        </dl>
      </section>

      @if (t.core_transaction_id || t.provider_name) {
        <section class="card-surface detail-card">
          <h2>Processing</h2>
          <dl class="detail-grid">
            <div><dt>Core Transaction ID</dt><dd>{{ t.core_transaction_id || '—' }}</dd></div>
            <div><dt>Provider</dt><dd>{{ t.provider_name || '—' }}</dd></div>
            <div><dt>Provider Response</dt><dd>{{ t.provider_response_code || '—' }} {{ t.provider_response_message }}</dd></div>
          </dl>
        </section>
      }

      <section class="card-surface detail-card">
        <h2>Audit History</h2>
        @if (audit().length === 0) {
          <p class="audit-empty">No audit events recorded.</p>
        } @else {
          <ol class="audit-timeline">
            @for (event of audit(); track event.created_at + event.event_type) {
              <li>
                <span class="audit-timeline__dot"></span>
                <div class="audit-timeline__body">
                  <div class="audit-timeline__row">
                    <span class="audit-type">{{ event.event_type.replaceAll('_', ' ') }}</span>
                    <span class="audit-time">{{ event.created_at | date: 'MMM d, y, h:mm a' }}</span>
                  </div>
                  <p class="audit-details">{{ event.event_details }}</p>
                  <p class="audit-actor">{{ event.actor_email }}</p>
                </div>
              </li>
            }
          </ol>
        }
      </section>
    </div>

    <aside class="detail-side">
      <section class="card-surface decision-card">
        <h2>Decision</h2>

        @if (decisionBanner(); as banner) {
          <p class="decision-banner">{{ banner }}</p>
        }

        @if (!isPending()) {
          <div class="decision-resolved">
            <app-status-badge [state]="t.state" />
            @if (t.approved_by) {
              <p>Approved by <strong>{{ t.approved_by }}</strong></p>
              @if (t.approved_at) {
                <p class="muted">{{ t.approved_at | date: 'MMM d, y, h:mm a' }}</p>
              }
            }
            @if (t.rejected_by) {
              <p>Rejected by <strong>{{ t.rejected_by }}</strong></p>
              @if (t.rejected_at) {
                <p class="muted">{{ t.rejected_at | date: 'MMM d, y, h:mm a' }}</p>
              }
              @if (t.rejection_reason) {
                <p class="muted">Reason: {{ t.rejection_reason }}</p>
              }
            }
          </div>
        } @else if (!canDecide()) {
          <p class="muted">Your role has read-only access and cannot approve or reject transactions.</p>
        } @else {
          <mat-form-field appearance="outline" class="reason-field">
            <mat-label>Rejection reason</mat-label>
            <textarea
              matInput
              rows="3"
              [(ngModel)]="rejectionReason"
              placeholder="Required to reject this transaction"
            ></textarea>
          </mat-form-field>

          <div class="decision-actions">
            <button
              mat-flat-button
              color="primary"
              [disabled]="deciding()"
              (click)="approve()"
            >
              Approve
            </button>
            <button
              mat-stroked-button
              color="warn"
              [disabled]="deciding() || !rejectionReason().trim()"
              (click)="reject()"
            >
              Reject
            </button>
          </div>
          <p class="decision-hint">Both actions are final and cannot be undone.</p>
        }
      </section>
    </aside>
  </div>
}
